const data = {
    terms: [
    {
            "term": "Amendment",
            "description": "a change to the Constitution of the United States"
        },
        {
            "term": "Bias",
            "description": "favoring a group of people or an idea"
        },
        {
            "term": "Biography",
            "description": "a story or book written about a person by another person"
        },
        {
            "term": "Black codes",
            "description": "laws passed in Southern states after the Civil War that restricted the freedom of African Americans"
        },
        {
            "term": "Brown v. Board of Education (1954)",
            "description": "A U.S. Supreme Court decision that ended segregation in public schools by overturning Plessy v. Ferguson (1896) and ruling that “Separate but Equal” was discriminatory."
        },
        {
            "term": "Change",
            "description": "taking action make something different"
        },
        {
            "term": "Civil disobedience",
            "description": "using nonviolent actions to try to change laws"
        },
        {
            "term": "Civil rights",
            "description": "rights granted to people by the government"
        },
        {
            "term": "Civil War Amendments (Reconstruction Amendments)",
            "description": "The 13th, 14th and 15th Amendments, passed between 1865 and 1870, that ended slavery, made freed slaves U.S. citizens with equal protection under the law, and guaranteed their right to vote."
        },
        {
            "term": "Community",
            "description": "a place or area where people live"
        },
        {
            "term": "Debate",
            "description": "a discussion where people talk about different sides of an issue"
        },
        {
            "term": "Democracy",
            "description": "a form of government where people have power and rights that cannot be taken away by the government"
        },
        {
            "term": "Discrimination",
            "description": "the act of treating people unfairly because of their appearance, background or actions"
        },
        {
            "term": "Disenfranchisement",
            "description": "taking away a person's right to vote"
        },
        {
            "term": "Equality",
            "description": "the idea that everyone is treated the same and has the same opportunities"
        },
        {
            "term": "Fairness",
            "description": "treating people the same without favoring one person or group over another"
        },
        {
            "term": "Freedmen's Bureau",
            "description": "A government agency created to help newly freed slaves, best known for supporting African American education and helping establish schools."
        },
        {
            "term": "Freedom",
            "description": "Being free and having rights"
        },
        {
            "term": "General election",
            "description": "taking action make something different+B25"
        },
        {
            "term": "Grandfather clause",
            "description": "a law used in Southern states to prevent freed slaves from voting by requiring their grandparents to have been citizens before the Civil War; ruled unconstitutional in 1915"
        },
        {
            "term": "Historically Black Colleges and Universities (HBCUs)",
            "description": "colleges and universities created to educate African Americans who were denied access to other schools because of discrimination"
        },
        {
            "term": "Inferior",
            "description": "lower in quality or status"
        },
        {
            "term": "Integration",
            "description": "bringing together or uniting groups, often referring to races or cultures"
        },
        {
            "term": "Intimidation",
            "description": "making someone feel afraid through threats or abuse of power"
        },
        {
            "term": "Jim Crow laws",
            "description": "laws passed in the South that enforced segregation and restricted the rights of African Americans after the Civil War"
        },
        {
            "term": "Judge",
            "description": "a person who hears legal cases and decides how to apply the law fairly"
        },
        {
            "term": "Justice",
            "description": "the principle of fairness for all people"
        },
        {
            "term": "Law",
            "description": "a rule established by the government that citizens must follow"
        },
        {
            "term": "Lawyer",
            "description": "a person, also called an attorney, who helps people with legal matters and represents them in court"
        },
        {
            "term": "Leadership",
            "description": "the ability to guide and help others"
        },
        {
            "term": "Legacy",
            "description": "something of importance passed down to future generations"
        },
        {
            "term": "Literacy test",
            "description": "a voter requirement in Southern states that forced people to prove they could read or explain the Constitution; used to keep African Americans from voting until banned in 1965"
        },
        {
            "term": "Mentor",
            "description": "someone who guides and supports another person to help them succeed"
        },
        {
            "term": "Minority",
            "description": "a group of people making up less than half of a country or area's population"
        },
        {
            "term": "Murray v. Pearson (1936)",
            "description": "a court case that forced the integration of the University of Maryland law school, with Thurgood Marshall helping Donald Murray become its first African American graduate"
        },
        {
            "term": "Negro (historical term)",
            "description": "a word once used to describe African Americans in the United States; it appears in historical documents but is not used today"
        },
        {
            "term": "Nomination",
            "description": "the act of choosing someone for a job or position"
        },
        {
            "term": "Overturn",
            "description": "when a new Supreme Court decision makes a previous decision no longer valid."
        },
        {
            "term": "Plessy v. Ferguson (1896)",
            "description": "a Supreme Court decision that made segregation legal under “separate but equal,” later overturned by Brown v. Board of Education (1954)."
        },
        {
            "term": "Poll tax",
            "description": "a fee people had to pay to vote, used to prevent African Americans from voting until outlawed by the 24th Amendment in 1964"
        },
        {
            "term": "Potential",
            "description": "the possibility of becoming better or greater in the future"
        },
        {
            "term": "Primary election",
            "description": "an election where voters choose a candidate from their political party to run in the general election"
        },
        {
            "term": "Racism",
            "description": "the belief that one race is better than others"
        },
        {
            "term": "Reconstruction",
            "description": "the period after the Civil War, from 1865 to 1877, when Southern states rejoined the Union and formerly enslaved people lived with new rights"
        },
        {
            "term": "Segregation",
            "description": "the act of separating people into groups, often by race."
        },
        {
            "term": "Self-esteem",
            "description": "how a person feels about themselves"
        },
        {
            "term": "Smith v. Allwright (1944)",
            "description": "a Supreme Court case that ended white primaries in the South"
        },
        {
            "term": "Solicitor general",
            "description": "the lawyer who represents the federal government before the Supreme Court"
        },
        {
            "term": "Supreme Court",
            "description": "the highest and most powerful court in the United States"
        },
        {
            "term": "Unanimous",
            "description": "when everyone agrees on a decision"
        },
        {
            "term": "Unconstitutional",
            "description": "not supported by the Constitution of the United States"
        },
        {
            "term": "Voting",
            "description": "the right to choose leaders or express an opinion in elections"
        },
        {
            "term": "Voting Rights Act (1965)",
            "description": "a law that banned discriminatory voting practices and enforced protections for African Americans' right to vote"
        },
        {
            "term": "White primary",
            "description": "an election in the South that only allowed white citizens to vote; declared illegal by the Supreme Court in Smith v. Allwright (1944)"
        }
]
}

export default data;